/*
 * Customily preview canvas toggle (mobile only)
 * Adds a button as the last child of .cl-canvas-container that shows/hides the
 * Customily live-preview canvas. Button is only visible on mobile.
 *
 * The .cl-canvas-container is injected by the Customily app after a delay, and
 * is re-created when the shopper changes variants — so we watch the DOM with a
 * MutationObserver and (re)attach the button whenever a container appears
 * without one. Self-contained, no jQuery dependency.
 */
(function () {
  'use strict';

  var LABEL_HIDE = 'Vorschau ausblenden';
  var LABEL_SHOW = 'Vorschau anzeigen';
  var MOBILE_MAX = 999; // mobile/tablet range; theme goes 2-column desktop at 1000px
  var BTN_ID = 'cl-canvas-toggle';
  var TYPING_ID = 'cl-canvas-toggle-typing';
  var COLLAPSED = 'cl-canvas-collapsed';

  function injectStyles() {
    if (document.getElementById('cl-canvas-toggle-styles')) { return; }
    var style = document.createElement('style');
    style.id = 'cl-canvas-toggle-styles';
    style.textContent =
      // Hidden by default; only shown on mobile while the canvas is pinned
      // (the sticky app adds .csh-sticky-mobile-fixed on an ancestor while
      // scrolled, and removes it when scrolled back to the top).
      '#' + BTN_ID + '{display:none !important;}' +
      // Show the button on mobile while the canvas is pinned (to collapse it) OR
      // whenever it's collapsed (so there's always a way to restore, even after
      // scrolling out of the sticky zone).
      '@media (max-width:' + MOBILE_MAX + 'px){.csh-sticky-mobile-fixed #' + BTN_ID + ',.cl-canvas-container.' + COLLAPSED + ' #' + BTN_ID + '{display:block !important;}}' +
      // Keep the preview hidden whenever collapsed — independent of pin state —
      // so scrolling past the ATC (which un-pins the canvas) doesn't pop it back
      // open. The button stays visible via the rule above, so no stuck state.
      '.cl-canvas-container.' + COLLAPSED + ' > :not(#' + BTN_ID + '){display:none !important;}' +
      // Keep focused inputs from scrolling under the sticky header (~4rem).
      ':root{scroll-padding-top:4rem;}' +
      '.customily-product-form input,.customily-product-form textarea,.customily-product-form select{scroll-margin-top:4rem;}' +
      // Collapsed but NOT pinned (e.g. the keyboard scroll made the sticky app
      // remove .csh-sticky-mobile-fixed): keep the restore button reachable by
      // fixing it to the viewport top, instead of letting it sit at the
      // canvas's natural absolute spot up at the media gallery. Scoped to
      // :not(.cl-typing) so it can never combine with the typing-state rules
      // (top + bottom both set = button stretched over the whole screen).
      '@media (max-width:' + MOBILE_MAX + 'px){' +
      'html:not(.cl-typing) .csh-sticky-mobile-container:not(.csh-sticky-mobile-fixed) .cl-canvas-container.' + COLLAPSED + ' #' + BTN_ID +
      '{position:fixed;top:4rem;left:0;right:0;z-index:50;}' +
      '}' +
      // While typing in a Customily field, slide ALL top overlays away —
      // header, announcement bar, and the pinned canvas bar (Chrome top-aligns
      // the focused field even when visible; with nothing pinned up there that
      // placement is already correct, so no corrective scroll runs). The
      // in-canvas button hides with its bar; the dedicated body-level typing
      // bar (#TYPING_ID) shows instead, docked above the keyboard — it hangs
      // off document.body, so nothing the sticky app un-pins can take it away.
      '#' + TYPING_ID + '{display:none;}' +
      '@media (max-width:' + MOBILE_MAX + 'px){' +
      'html.cl-typing .shopify-section--header,html.cl-typing .announcement-bar,html.cl-typing .csh-sticky-mobile-fixed' +
      '{transform:translateY(-120%) !important;transition:none !important;}' +
      'html.cl-typing #' + BTN_ID + '{display:none !important;}' +
      'html.cl-typing #' + TYPING_ID + '{display:block;position:fixed;top:0;left:0;right:0;z-index:50;}' +
      '}';
    document.head.appendChild(style);
  }

  function buildButton() {
    var btn = document.createElement('button');
    btn.id = BTN_ID;
    btn.type = 'button';
    btn.textContent = LABEL_HIDE; // canvas starts visible
    btn.style.cssText =
      'display:block;margin:0;padding:12px;cursor:pointer;' +
      'background:#ED2079;color:#fff;font-weight:bold;border:none;' +
      'font-size:14px;line-height:1.2;text-align: center;margin-top: -8px;';

    btn.addEventListener('click', function () {
      var el = btn.closest('.cl-canvas-container');
      if (!el) { return; }
      var isCollapsed = el.classList.toggle(COLLAPSED);
      btn.textContent = isCollapsed ? LABEL_SHOW : LABEL_HIDE;
    });

    return btn;
  }

  // Body-level bar shown only while typing (html.cl-typing), docked above the
  // keyboard. Deliberately NOT inside .cl-canvas-container: the sticky app
  // hides/un-pins that whole tree when the keyboard opens, which would take an
  // in-canvas button with it. Tapping it closes the keyboard (blur) and
  // expands the preview in one gesture.
  function ensureTypingBar() {
    if (document.getElementById(TYPING_ID)) { return; }
    var bar = document.createElement('button');
    bar.id = TYPING_ID;
    bar.type = 'button';
    bar.textContent = LABEL_SHOW; // typing implies collapsed
    bar.style.cssText =
      'padding:12px;cursor:pointer;background:#ED2079;color:#fff;font-weight:bold;' +
      'border:none;font-size:14px;line-height:1.2;text-align:center;';
    bar.addEventListener('click', function () {
      if (document.activeElement && document.activeElement.blur) {
        document.activeElement.blur(); // close the keyboard
      }
      setCollapsed(false);
      autoCollapsed = false;
    });
    document.body.appendChild(bar);
  }

  // Glue the typing bar to the bottom of the VISIBLE area. The CSS bottom:0
  // fallback pins it to the layout viewport — which the keyboard covers when
  // the browser doesn't resize that viewport (iOS never does; Android Chrome
  // doesn't here because of height=device-height in the viewport meta). The
  // visualViewport API reports the truly visible rect, so position against it.
  function positionTypingBar() {
    var bar = document.getElementById(TYPING_ID);
    if (!bar || !window.visualViewport) { return; }
    if (!document.documentElement.classList.contains('cl-typing')) { return; }
    var vv = window.visualViewport;
    bar.style.bottom = 'auto';
    bar.style.top = '0';
    // Top of the VISIBLE area (offsetTop matters on iOS, where the layout
    // viewport can be panned while the keyboard is open).
    bar.style.transform = 'translateY(' + vv.offsetTop + 'px)';
  }

  // Idempotent: ensures the current container has our button. Runs on every
  // observer tick, so keep it cheap and guard against duplicate work.
  function ensureToggle() {
    var canvas = document.querySelector('.cl-canvas-container');
    if (!canvas) { return; }
    injectStyles();
    ensureTypingBar();
    if (canvas.querySelector('#' + BTN_ID)) { return; } // already attached
    canvas.appendChild(buildButton()); // last child of .cl-canvas-container
  }

  // Watch for the container being injected / re-created by the app.
  var observer = new MutationObserver(ensureToggle);
  observer.observe(document.body, { childList: true, subtree: true });

  // If the viewport grows past the mobile breakpoint, the button is hidden —
  // make sure the canvas isn't left collapsed from an earlier mobile toggle.
  window.addEventListener('resize', function () {
    if (window.innerWidth > MOBILE_MAX) {
      var el = document.querySelector('.cl-canvas-container');
      if (el) { el.classList.remove(COLLAPSED); }
      var btn = document.getElementById(BTN_ID);
      if (btn) { btn.textContent = LABEL_HIDE; }
    }
  });

  // Also try immediately / on the Customily event, in case the container is
  // already present before the observer catches a mutation.
  window.addEventListener('customily-options-loaded', ensureToggle);
  ensureToggle();

  /*
   * Keep focused Customily inputs from landing under the sticky header.
   * Android's on-screen keyboard auto-scrolls the focused input to the very
   * top of the viewport and ignores CSS scroll-margin/scroll-padding for that
   * scroll. So after the keyboard opens we re-scroll the input to sit below
   * the actual sticky/fixed header, whose height we measure at runtime.
   */
  var HEADER_GAP = 28; // px of breathing room below the overlay
  var HEADER_SELECTORS = ['store-header.header', '.header', '.section-header', '.announcement-bar'];

  // True if el, or any ancestor, is pinned to the viewport (fixed/sticky).
  // The Customily canvas itself is often static inside a fixed wrapper
  // (.csh-sticky-mobile-fixed), so checking only the element isn't enough.
  function isPinned(el) {
    for (var n = el; n && n !== document.body; n = n.parentElement) {
      var pos = getComputedStyle(n).position;
      if (pos === 'fixed' || pos === 'sticky') { return true; }
    }
    return false;
  }

  // Bottom edge (in viewport coords) of what's pinned to the top of the screen.
  // Always counts the sticky header. Counts the Customily canvas only when it's
  // collapsed — so an EXPANDED canvas doesn't push inputs off-screen; when
  // collapsed we still clear the small toggle button.
  function coveredTop() {
    var max = 0;
    var selectors = HEADER_SELECTORS.slice();
    var canvas = document.querySelector('.cl-canvas-container.' + COLLAPSED);
    if (canvas) { selectors.push('.cl-canvas-container.' + COLLAPSED); }
    // The typing bar sits at the top while the keyboard is open — the focused
    // field must be corrected to below it. (Hidden bar has height 0, so this
    // contributes nothing outside typing mode.)
    selectors.push('#' + TYPING_ID);

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (!isPinned(el)) { return; }
        var rect = el.getBoundingClientRect();
        // Only elements pinned near the TOP count as covering the top of the
        // viewport — the toggle bar docked at the bottom while typing has a
        // large rect.bottom but occludes nothing up there.
        if (rect.height > 0 && rect.bottom > 0 && rect.top < 150) {
          max = Math.max(max, rect.bottom);
        }
      });
    });
    return max;
  }

  // Selector-agnostic: match ANY editable text field that isn't part of the
  // sticky header. This avoids depending on Customily's exact wrapper markup
  // (tag vs class vs id), which re-renders and differs between states.
  var NON_TEXT_TYPES = /^(checkbox|radio|button|submit|reset|range|color|file|image|hidden)$/;
  function isCustomilyInput(el) {
    if (!el || !el.closest) { return false; }
    if (!/^(INPUT|TEXTAREA)$/.test(el.tagName)) { return false; }
    var type = (el.getAttribute('type') || 'text').toLowerCase();
    if (NON_TEXT_TYPES.test(type)) { return false; }
    // Don't fight fields that live inside the sticky header (e.g. search).
    if (el.closest(HEADER_SELECTORS.join(','))) { return false; }
    return true;
  }

  // Don't correct offsets smaller than this. The hide-on-scroll header and the
  // keyboard's suggestion bar jitter coveredTop() by a few px; correcting every
  // wiggle reads as the page sliding down and up.
  var SLACK = 8;

  // Scroll so `input` sits `target`px from the viewport top. Uses
  // scrollIntoView (it targets whatever container actually scrolls, unlike
  // window.scrollBy) with a one-off scroll-margin that is removed straight
  // after — a lingering inline scroll-margin makes the browser's own
  // caret-reveal scroll (tapping an already-focused field) jump the page.
  function liftInput(input, target) {
    if (!input.scrollIntoView) { return; }
    input.style.scrollMarginTop = target + 'px';
    input.scrollIntoView({ block: 'start' });
    input.style.scrollMarginTop = '';
  }

  function correctInputScroll(input) {
    if (window.innerWidth > MOBILE_MAX) { return; } // mobile only
    if (!input || !input.getBoundingClientRect) { return; }
    var covered = coveredTop();
    // Nothing pinned on top (normal while typing, since .cl-typing slides the
    // overlays away) — the browser's own placement is fine, don't touch it.
    if (covered === 0) { return; }
    var target = covered + HEADER_GAP;

    // Only act when the input is genuinely tucked under the overlay. Keeps
    // this safe to call on every scroll tick without snapping back the
    // shopper's own scrolling or reacting to px-level jitter.
    if (input.getBoundingClientRect().top >= target - SLACK) { return; }

    liftInput(input, target);

    // Fallback: if the scroller ignored scrollIntoView, nudge the window.
    var top = input.getBoundingClientRect().top;
    if (top < target - SLACK) { window.scrollBy(0, top - target); }
  }

  // Collapse/expand the canvas and keep the toggle button label in sync.
  function setCollapsed(state) {
    var canvas = document.querySelector('.cl-canvas-container');
    if (!canvas || canvas.classList.contains(COLLAPSED) === state) { return; }
    canvas.classList.toggle(COLLAPSED, state);
    var btn = canvas.querySelector('#' + BTN_ID);
    if (btn) { btn.textContent = state ? LABEL_SHOW : LABEL_HIDE; }
  }

  // Tracks whether WE auto-collapsed on focus (so we only auto-restore that,
  // never a canvas the shopper collapsed manually).
  var autoCollapsed = false;
  // While Date.now() < this, keep correcting on scroll/resize. Covers the slow
  // FIRST keyboard open, whose late scroll-to-top fires after the timeouts.
  var correctUntil = 0;

  // The browser does its own auto-scroll as the keyboard opens; run our
  // correction repeatedly for a short window afterward to win against it —
  // especially the first open, which animates slowly.
  document.addEventListener('focusin', function (e) {
    if (!isCustomilyInput(e.target)) { return; }
    var input = e.target;

    // Auto-collapse the preview so it doesn't cover the field / keyboard.
    if (window.innerWidth <= MOBILE_MAX) {
      var canvas = document.querySelector('.cl-canvas-container');
      if (canvas && !canvas.classList.contains(COLLAPSED)) {
        setCollapsed(true);
        autoCollapsed = true;
      }

      // Slide the pinned overlays out of the way for the whole typing session.
      // Applied synchronously, so by the time the browser runs its own
      // focus-scroll (which top-aligns the field) nothing covers the top of
      // the viewport and its placement needs no correction.
      document.documentElement.classList.add('cl-typing');
      positionTypingBar(); // initial spot; vv resize refines it as the keyboard opens
    }

    correctUntil = Date.now() + 1500;
    [0, 150, 350, 600, 900, 1200].forEach(function (t) {
      setTimeout(function () { correctInputScroll(input); }, t);
    });
  });

  // Counter the browser's late scroll-to-top during the post-focus window.
  // Time-boxed + the "already clear" guard in correctInputScroll mean this
  // never fights the shopper's own scrolling once the field is positioned.
  window.addEventListener('scroll', function () {
    if (Date.now() > correctUntil) { return; }
    if (isCustomilyInput(document.activeElement)) {
      correctInputScroll(document.activeElement);
    }
  }, { passive: true });

  // On blur, bring the overlays back and restore the preview (the latter only
  // if we auto-collapsed it). Debounced so focus moving between two Customily
  // fields doesn't flicker the header/canvas in and out.
  document.addEventListener('focusout', function () {
    setTimeout(function () {
      if (isCustomilyInput(document.activeElement)) { return; }
      document.documentElement.classList.remove('cl-typing');
      if (autoCollapsed) {
        setCollapsed(false);
        autoCollapsed = false;
      }
    }, 150);
  });

  // Keep the typing bar on the visible bottom edge as the keyboard opens,
  // closes, or the visual viewport pans. Re-correct input scroll only inside
  // the post-focus window — unbounded, the keyboard's suggestion bar toggling
  // WHILE TYPING fires this and causes surprise slides long after focus.
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', function () {
      positionTypingBar();
      if (Date.now() > correctUntil) { return; }
      if (isCustomilyInput(document.activeElement)) {
        correctInputScroll(document.activeElement);
      }
    });
    window.visualViewport.addEventListener('scroll', positionTypingBar);
  }
})();